import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

var hamburger = {
    selector: '.hamburger',
    init: function() {
        var self = this,
            $hamburger = $( self.selector ),
            $navigation = $( '.navigation' );

        var navigation = document.querySelector( '.navigation__container' );

        $hamburger.on( 'click', function( e ) {
            $navigation.addClass( 'navigation--animate' );
            $( document.body ).toggleClass( 'navigation-opened' );

            if ( $( document.body ).hasClass( 'navigation-opened' ) ) {
                disableBodyScroll( navigation, { reserveScrollBarGap: true } );
                var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
                $( document.body ).addClass( 'navigation-opened-prepare' );
            } else {
                enableBodyScroll( navigation );

                $navigation.one( 'animationend', function() {
                    $( document.body ).removeClass( 'navigation-opened-prepare' );
                } );
            }
        } );

        $( window ).on( 'resize', function( e ) {
            $navigation.removeClass( 'navigation--animate' );
            $( document.body ).removeClass( 'navigation-opened navigation-opened-prepare' );
            clearAllBodyScrollLocks();
        } );
    }
}

export {
    hamburger
};
